"use client";

import React from "react";
import { Shield, Lock, Server } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function BuildingASaferSpace() {
  const {
    ref: sectionRef,
    isVisible: isSectionVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="123071" id="your-capital-control" className="dark bg-background text-foreground relative flex min-h-[80vh] items-center justify-center overflow-hidden py-24 sm:py-32" ref={sectionRef}>
      {}
      <div className="absolute inset-0 bg-background" aria-hidden="true" />

      {}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-primary/20 rounded-full blur-[120px] pointer-events-none" aria-hidden="true" />
      <div className="absolute bottom-0 right-0 w-[400px] h-[400px] bg-chart-2/10 rounded-full blur-[100px] pointer-events-none" aria-hidden="true" />

      {}
      <div className="absolute inset-0 bg-[linear-gradient(to_right,#ffffff03_1px,transparent_1px),linear-gradient(to_bottom,#ffffff03_1px,transparent_1px)] bg-[size:4rem_4rem] [mask-image:radial-gradient(ellipse_60%_60%_at_50%_50%,#000_70%,transparent_100%)] pointer-events-none" aria-hidden="true" />

      <div className="container relative z-10 mx-auto px-4 md:px-6">
        <div className={`mx-auto flex max-w-3xl flex-col items-center text-center transition-all duration-1000 ease-out ${isSectionVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          {}
          <div className="relative mb-12 flex items-center justify-center">
            {}
            <div className="absolute inset-0 animate-ping rounded-full bg-primary/20 opacity-20 duration-3000" />
            <div className="absolute -inset-4 rounded-full border border-primary/20 bg-primary/5 backdrop-blur-sm" />
            <div className="absolute -inset-8 rounded-full border border-chart-2/10 bg-chart-2/5 backdrop-blur-md" />
            
            {}
            <div className="relative flex h-24 w-24 items-center justify-center rounded-sm border border-white/10 bg-card/50 shadow-[0_0_40px_rgba(0,0,0,0.8)] backdrop-blur-xl">
              <Shield className="h-12 w-12 text-primary drop-shadow-[0_0_15px_rgba(var(--color-primary),0.6)]" />
              
              {}
              <div className="absolute -right-2 -top-2 flex h-8 w-8 items-center justify-center rounded-sm border border-white/10 bg-background/90 backdrop-blur-md">
                <Lock className="h-4 w-4 text-primary" />
              </div>
              <div className="absolute -bottom-2 -left-2 flex h-8 w-8 items-center justify-center rounded-sm border border-white/10 bg-background/90 backdrop-blur-md">
                <Server className="h-4 w-4 text-chart-2" />
              </div>
            </div>
          </div>

          {}
          <h1 className="text-4xl font-black tracking-tighter text-foreground sm:text-6xl md:text-7xl lg:text-8xl">
            Unrestricted <br className="hidden sm:block" />
            <span className="bg-gradient-to-r from-primary via-primary to-chart-2 bg-clip-text text-transparent">
              Capital Flow
            </span>
          </h1>
          
          <p className="mt-6 max-w-2xl text-lg font-medium leading-relaxed text-muted-foreground sm:text-xl">
            Experience institutional agility with 24/7 Access and Zero Hidden Fees. TradeSphere empowers your strategy with instant liquidity and total control over your assets, exactly when you need them.
          </p>

          {}
          <div className="mt-10 flex flex-col gap-4 sm:flex-row sm:justify-center">
            <Button asChild size="lg" className="h-12 px-8 text-base font-bold rounded-sm shadow-[0_0_20px_rgba(var(--color-primary),0.4)] hover:shadow-[0_0_30px_rgba(var(--color-primary),0.6)] transition-all bg-primary text-primary-foreground">
              <Link to="/FundingPage">
                Add Funds Now
              </Link>
            </Button>
            <Button asChild variant="outline" size="lg" className="h-12 px-8 text-base font-bold rounded-sm border-white/10 bg-white/5 backdrop-blur-sm hover:bg-white/10 text-foreground transition-all">
              <Link to="/AcademyPage">
                Explore Academy
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}